import React from "react";
import Weather from "./Weather.js";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Ede" />
        <footer>
          Open source on{" "}
          <a
            href="https://github.com/AleksRu21/w5-weather-project"
            target="_blank"
            rel="noreferrer"
          >
            Git Hub
          </a>{" "}
          created by{" "}
          <a href="https://www.linkedin.com/in/aleksandra-rudyak/">
            Aleksandra Rudyak
          </a>
        </footer>
      </div>
    </div>
  );
}

export default App;
